// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { loadSites, initialGetUserProfile } from '../../actions/actions';
import Article from 'grommet/components/Article';
import Button from 'grommet/components/Button';
import FormField from 'grommet/components/FormField';
import Footer from 'grommet/components/Footer';
import Form from 'grommet/components/Form';
import NavControl from '../NavControl';
import TextInput from 'grommet/components/TextInput';
import { browserHistory as history } from 'react-router';
import constants from '../../Constants';
import { navEnable } from '../../actions/nav';
import { updateProfile, updateUserLocation } from '../../actions/settings';

var profileData = {};
class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.imageUpload = this.imageUpload.bind(this);
    this.update = this.update.bind(this);
    this.cancel = this.cancel.bind(this);
    this.profileDataChange = this.profileDataChange.bind(this);
    this.chooseLocation = this.chooseLocation.bind(this);
    this.state = {
      display: true
    }
  }
  componentWillMount() {
    profileData = {};
    this.props.dispatch(navEnable(true));
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {
    profileData = {};
    let position = this.props.userProfile.siteLocation && this.props.userProfile.siteLocation.latitude ? this.props.userProfile.siteLocation : {};
    this.props.dispatch(updateUserLocation(position));
    // this._graphicSizer.stop();
  }

  imageUpload(event) {
      // console.log('e', event)
    let _this = this
    if (event.target.files && event.target.files[0]) {

      let sizeOfImageInKb = event.target.files[0].size * 0.001;
      if (sizeOfImageInKb > 800) {
        alert('Image size exceeds 800 Kb!. Please select another image.');
        _this.refs.inputFile.value = '';
      } else {
        var FR = new FileReader();

        FR.addEventListener("load", function (e) {

          let imageinBase64 = e.target.result;

          let splitedArr = imageinBase64.split(',')
          _this.refs.profilePic.src = 'data:image/jpeg;base64,' + splitedArr[1];
          profileData['profileImage'] = splitedArr[1];
          // document.getElementById("b64").innerHTML = e.target.result;
        });

        FR.readAsDataURL(event.target.files[0]);
      }

    }
  }

  profileDataChange(key, event) {
    profileData[key] = event.target.value
  }

  chooseLocation() {
    history.push({
      pathname: constants.ROUTES.CHOOSE_LOCATION,
      // search: '?name=' + sitename_enc,
      state: {}
    })
  }

  update() {

    if (this.props.userLocation.latitude) {
      profileData['siteLocation'] = {
        latitude: this.props.userLocation.latitude,
        longitude: this.props.userLocation.longitude
      }
    }
    this.props.dispatch(updateProfile(profileData));
    // profileData={};
  }

  cancel() {
      // console.log('forceUpdate')
    this.setState({
      display: false
    }, () => {
      this.setState({
        display: true
      })
    })
    // initialGetUserProfile(localStorage.userId)
  }

  getLocation() {
    if(this.props.userProfile && this.props.userProfile.username){
      if (this.props.userLocation.latitude) {
        return 'Latitude:' + this.props.userLocation.latitude.toFixed(3) + ', Longitude:' + this.props.userLocation.longitude.toFixed(3);
      } else {
        return '';
      }
    }
  }


  render() {
    if (this.props.userProfile && this.state.display) {
      // alert(this.props.userProfile.profileImage)
      return (
        <div className="settings">

          <div className="header">
            <div className="image-container">
              {
                this.props.userProfile.profileImage && this.props.userProfile.profileImage.length > 0 ? <img ref="profilePic" src={'data:image/jpeg;base64,' + this.props.userProfile.profileImage} alt="" /> : <img ref="profilePic" src="" alt="" />
              }

            </div>

            <div className="user-name inlineblock">
              {this.props.userProfile.displayName}
            </div>
            <input type="file" id="myFile" size="50" accept="image/*" className="input-upload" ref='inputFile' onChange={this.imageUpload.bind(this)} />
          </div>
          <div className="edit-controls">
            <div className="item maxwidth">
              <div className="label inlineblock">User Name</div>
              <div className="control inlineblock">
                <input className="maxwidth" onChange={this.profileDataChange.bind(this, 'username')} defaultValue={this.props.userProfile.username} type="text" />
              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock">Full Name</div>
              <div className="control inlineblock">
                <input className="maxwidth" onChange={this.profileDataChange.bind(this, 'displayName')} defaultValue={this.props.userProfile.displayName} type="text" />
              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock">Password</div>
              <div className="control inlineblock">
                <input className="maxwidth" onChange={this.profileDataChange.bind(this, 'password')} type="password" />
              </div>
            </div>
            <div className="item maxwidth">
              <div className="label inlineblock">Email</div>
              <div className="control inlineblock">
                <input className="maxwidth" onChange={this.profileDataChange.bind(this, 'email')} defaultValue={this.props.userProfile.email} type="text" />
              </div>
            </div>
            {/*<div className="item maxwidth">*/}
              {/*<div className="label inlineblock">Site Name</div>*/}
              {/*<div className="control inlineblock">*/}
                {/*<input className="maxwidth" onChange={this.profileDataChange.bind(this, 'siteName')} defaultValue={this.props.userProfile.siteName} type="text" />*/}
              {/*</div>*/}
            {/*</div>*/}
            {/*<div className="item maxwidth">*/}
              {/*<div className="label inlineblock">Site Location</div>*/}
              {/*<div className="control inlineblock">*/}
                {/*<p className="location-text">*/}
                  {/*{this.getLocation()}*/}
                  {/*<button className="location-btn" onClick={this.chooseLocation}>Change Location</button>*/}
                {/*</p>*/}
              {/*</div>*/}
            {/*</div>*/}
          </div>
          <div className="overlay-btn-container">
            <Button label='Update'
              className='lighter-font'
              onClick={this.update}
              primary={true}
              secondary={false}
              accent={false} />

            <Button label='Cancel'
              className='lighter-font'
              onClick={this.cancel}
              primary={true}
              secondary={false}
              accent={false} />
          </div>

        </div>

      );
    } else {
      return null;
    }

  }

}

Dashboard.propTypes = {
  dashboard: PropTypes.object,
  search: PropTypes.object
};

let select = (state, props) => ({

  userProfile: state.user.profile,
  userLocation: state.user.position
});

export default connect(select)(Dashboard);



// WEBPACK FOOTER //
// ./src/js/components/settings/Settings.js